import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { Save } from '@mui/icons-material';
import { colors } from '../../themes/typography';

/**
 * Reusable discount input component with save button
 * Extracted from ExperimentPanel for shared use
 */
const DiscountInput = ({
  productKey,
  isEditable,
  discountInputs,
  effectiveDiscount,
  pendingSaves,
  onDiscountInputChange,
  onDiscountReset,
  onSaveChanges,
  t
}) => {
  if (!isEditable) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
        <Typography sx={{
          fontSize: '10px',
          color: colors.text.primary,
          fontWeight: 600,
          lineHeight: 1.2
        }}>
          {effectiveDiscount}
        </Typography>
        <Typography sx={{
          fontSize: '10px',
          color: colors.text.secondary,
          fontWeight: 700,
          lineHeight: 1.2
        }}>
          %
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <TextField
        value={discountInputs[productKey] !== undefined ? discountInputs[productKey] : effectiveDiscount.toString()}
        onChange={(e) => onDiscountInputChange(productKey, e.target.value)}
        onDoubleClick={() => onDiscountReset(productKey)}
        size="small"
        inputProps={{ 
          style: { 
            fontSize: '10px', 
            padding: '1px 2px',
            textAlign: 'center',
            width: '25px'
          }
        }}
        sx={{
          width: '35px',
          '& .MuiOutlinedInput-root': {
            height: '16px',
            fontSize: '10px',
            '& fieldset': {
              borderColor: colors.border.light,
              borderWidth: '1px'
            },
            '&:hover fieldset': {
              borderColor: colors.action.primary
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.action.primary,
              borderWidth: '1px'
            }
          }
        }}
        title="Double-click to reset"
      />
      <Typography sx={{
        fontSize: '10px',
        color: colors.text.secondary,
        fontWeight: 500,
        lineHeight: 1.2
      }}>
        %
      </Typography>
      {/* Save button - show when combo or discount has been modified */}
      {pendingSaves[productKey] && (
        <Box
          onMouseDown={(e) => {
            // Capture main scroll container position before save
            const mainScrollContainer = document.querySelector('.css-4z6nar');
            if (mainScrollContainer) {
              window.savedColumnScroll = {
                scrollTop: mainScrollContainer.scrollTop
              };
            }
          }}
          onClick={() => onSaveChanges(productKey)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '2px',
            backgroundColor: colors.action.primary,
            color: 'white',
            borderRadius: '4px',
            px: '4px',
            py: '1px',
            cursor: 'pointer',
            fontSize: '9px',
            fontWeight: 500,
            lineHeight: 1,
            ml: '2px',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            '&:hover': {
              backgroundColor: colors.action.primaryDark || '#1976d2',
              transform: 'translateY(-0.5px)',
              boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
            },
            '&:active': {
              transform: 'translateY(0px)',
              boxShadow: '0 1px 2px rgba(0,0,0,0.1)'
            }
          }}
          title="Save changes"
        >
          <Save sx={{ fontSize: '8px' }} />
          <Typography sx={{ 
            fontSize: '9px', 
            fontWeight: 500,
            color: 'white',
            lineHeight: 1
          }}>
{t('save')}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default DiscountInput;